/** Event-scoped CRUD roles — mirrors backend/utils/eventRoles.js */

export const EVENT_ROLES = ["Manager", "Editor", "Viewer"];

export const ROLE_DEFINITIONS = [
  {
    key: "Manager",
    label: "Manager",
    summary: "Full operational control",
    capabilities: [
      "Create, edit, and delete records",
      "Enable or disable operational data",
      "Use all pages granted to this event",
    ],
    cannot: ["Manage Event Users (Event Admin only)"],
  },
  {
    key: "Editor",
    label: "Editor",
    summary: "Create and update",
    capabilities: [
      "Create and edit records",
      "Send invites and update RSVP where allowed",
      "Use pages granted to this event",
    ],
    cannot: ["Delete or permanently remove records", "Manage Event Users"],
  },
  {
    key: "Viewer",
    label: "Viewer",
    summary: "Read-only",
    capabilities: [
      "View dashboards and lists",
      "Export / print where available",
      "Use pages granted to this event",
    ],
    cannot: ["Create, edit, or delete any data", "Manage Event Users"],
  },
];

export const canEditData = (role) =>
  role === "Manager" || role === "Editor" || role === "Admin";

export const canDeleteData = (role) =>
  role === "Manager" || role === "Admin";

export const isReadOnlyRole = (role) => role === "Viewer";
